import React, { useEffect, useRef } from 'react';
import { ScrollView, Text, View } from 'react-native';
import { t } from 'i18next';
import { useColorScheme } from 'nativewind';
import { Notification } from '../index';
import { useNotifications } from '../../contexts/Notification/NotificationContext';
import { isTablet } from '../../utils/responsive';

interface Props {
  notiVisible: boolean;
}

const NotificationPopover: React.FC<Props> = ({ notiVisible }) => {
  const { notifications, timeAgoCalc, fetchNotifications, setNotificationsSeen } =
    useNotifications();
  const { colorScheme } = useColorScheme();

  const containerRef = useRef(null);

  // TODO: Ne lehessen ezen a komponensen görgetve ellapozni az egész oldalt. Egyelőre nem működik még így
  useEffect(() => {
    const preventScroll = (e) => {
      const container = containerRef.current;
      if (!container || !container.contains(e.target)) {
        e.preventDefault();
        return;
      }

      // When scrollView is at top or bottom also prevent scrolling of page
      const isAtTop = container.scrollTop === 0;
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;

      if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    };

    const handleMouseEnter = () => {
      if (!isTablet) {
        document.addEventListener('wheel', preventScroll, { passive: false });
        document.addEventListener('touchmove', preventScroll, { passive: false });
      }
    };

    const handleMouseLeave = () => {
      if (!isTablet) {
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
      }
    };

    const container = containerRef.current;

    if (container && !isTablet) {
      container.addEventListener('mouseenter', handleMouseEnter);
      container.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (container && !isTablet) {
        container.removeEventListener('mouseenter', handleMouseEnter);
        container.removeEventListener('mouseleave', handleMouseLeave);
      }
      if (!isTablet) {
        document.removeEventListener('wheel', preventScroll);
        document.removeEventListener('touchmove', preventScroll);
      }
    };
  }, []);

  useEffect(() => {
    timeAgoCalc();
    return () => {
      seenNotification();
    };
  }, [notiVisible]);

  const seenNotification = async () => {
    if (notifications?.some((notification) => !notification.seenAtUtc)) {
      await setNotificationsSeen();
      fetchNotifications();
    }
  };

  const renderedNotifications = notifications?.map((notification) => {
    return <Notification key={notification.id} notificationData={notification} />;
  });

  return renderedNotifications.length > 0 ? (
    <ScrollView
      testID="notification-popover"
      style={{
        display: notiVisible ? 'flex' : 'none',
        position: 'absolute',
        right: 0,
        zIndex: 0,
        top: 56,
        width: 330,
        maxHeight: 396,
        flexDirection: 'column',
        backgroundColor: colorScheme === 'dark' ? '#000' : '#fff',
      }}
      ref={containerRef}
      persistentScrollbar={true}
      contentContainerStyle={{ alignItems: 'flex-end', justifyContent: 'flex-start' }}
      indicatorStyle={colorScheme === 'dark' ? 'white' : 'black'}
    >
      {renderedNotifications}
    </ScrollView>
  ) : (
    <View
      style={{
        display: notiVisible ? 'flex' : 'none',
        position: 'absolute',
        right: 0,
        zIndex: 0,
        top: 56,
        width: 330,
        minHeight: 264,
        backgroundColor: colorScheme === 'dark' ? '#000' : '#fff',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      ref={containerRef}
    >
      <Text
        style={{
          fontFamily: 'sans-400',
          fontSize: 16,
          lineHeight: 20,
          color: colorScheme === 'dark' ? '#edf115' : '#967CFF',
        }}
      >
        {t('notifications:no_new_notifications')},
      </Text>
      <Text
        style={{
          fontFamily: 'sans-400',
          fontSize: 16,
          lineHeight: 20,
          color: colorScheme === 'dark' ? '#f6f6f6' : '#101010',
        }}
      >
        {t('notifications:check_back_later')}
      </Text>
    </View>
  );
};
export default NotificationPopover;
